import { useMutation, useQuery } from "@tanstack/react-query";


import { uploadImageAPI } from "@src/api/raffle-draw";
import { rafflepageAPI, rafflePageDetailsAPI } from "@src/api/rewards-management";
import { usePartnerDropdownContext } from "@src/context/PartnerDropdown";
import { useToasterContext } from "@src/context/Toaster";
import { UseRafflePageEditorServiceOperators } from "@src/lib/types/raffle-page-editor";
import { AlertType } from "@src/lib/types/toaster";


export const useServices = (): Readonly<UseRafflePageEditorServiceOperators> => {
  const { triggerOpen } = useToasterContext();
  const { state: { selectedPartnerId } } = usePartnerDropdownContext();

  const { data, isLoading } = useQuery({
    queryKey: ["raffle-page-content", {selectedPartnerId}],
    queryFn: async () => {
      const result = await rafflePageDetailsAPI({ partnerId: selectedPartnerId });

      return result;
    },
  });

  const onPublish = useMutation({
    mutationKey: ['publish-content', {selectedPartnerId}],
    mutationFn: async (params?: Partial<any>) => {
      const result = await rafflepageAPI({ ...params, partnerId: selectedPartnerId });
      return result;
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Publish Content",
        message: "Failed to publish.",
      });
    },
  });

  const uploadImage = useMutation({
    mutationKey: ['upload-image'],
    mutationFn: async (params?: Partial<any>) => {
      const result = await uploadImageAPI(params);
      return {
        type: params?.get("type"),
        result: result?.data ?? {}
      };
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Uploading Image",
        message: "Failed to upload image.",
      });
    },
  });

  return {
    data,
    isLoading,
    uploadImage,
    onPublish
  };
};
